import commonService from '@/services/common'

const defaultState = () => ({
    states: null,
    jobCategories: null,
    provinces: null,
    religions: null,
    carTypes: null,
    // marryTypes: null,
    // childTypes: null,
    incomeTypes: null,
    assetTypes: null,
    exercises: null,
    houseStyles: null,
    housePayments: null,
    schools: null,
    schoolTypes: null,
    profileOptions: null,
    lastApiCall: null,
    payloads: {
        signupData: {
            optional_consent: 0,
            email: '',
            nickname: '',
            password: '',
        },
    },
})

const state = defaultState()

const getters = {
    states: state => state.states,
    jobCategories: state => state.jobCategories,
    provinces: state => state.provinces,
    schools: state => state.schools,
    schoolTypes: state => state.schoolTypes,
    shapes: state => {
        if (!state.profileOptions) return

        return state.profileOptions.filter(o => o.ptype === 'shape')
    },
    kinds: state => {
        if (!state.profileOptions) return

        return state.profileOptions.filter(o => o.ptype === 'kind')
    },
    mbti: state => {
        if (!state.profileOptions) return

        return state.profileOptions.filter(o => o.ptype === 'mbti')
    },
    religions: state => {
        if (!state.profileOptions) return

        return state.profileOptions.filter(o => o.ptype === 'religion')
    },
    carTypes: state => {
        if (!state.profileOptions) return

        return state.profileOptions.filter(o => o.ptype === 'car_type')
    },
    incomeTypes: state => {
        if (!state.profileOptions) return

        return state.profileOptions.filter(o => o.ptype === 'income')
    },
    assetTypes: state => {
        if (!state.profileOptions) return

        return state.profileOptions.filter(o => o.ptype === 'asset')
    },
    exercises: state => {
        if (!state.profileOptions) return

        return state.profileOptions.filter(o => o.ptype === 'exercise')
    },
    houseStyles: state => {
        if (!state.profileOptions) return

        return state.profileOptions.filter(o => o.ptype === 'house_style')
    },
    housePayments: state => {
        if (!state.profileOptions) return

        return state.profileOptions.filter(o => o.ptype === 'house_payment')
    },
    lastApiCall: state => state.lastApiCall,
    payloads: state => state.payloads,
}

const actions = {
    async loadConstants({ commit }) {
        try {
            const constants = await commonService.constants()
            const profileOptions = await commonService.profileOptions()
            commit('setConstants', {
                constants,
                profileOptions,
            })
        } catch (e) {
            Promise.reject(e)
        }
    },
}

const mutations = {
    async setConstants(state, { constants, profileOptions }) {
        state.states = constants.states
        state.jobCategories = constants.job_categories
        state.schools = constants.schools
        state.schoolTypes = constants.school_types
        state.provinces = constants.provinces
        state.religions = constants.religions
        state.profileOptions = profileOptions
    },
    setPayloads(state, payloads) {
        Object.keys(payloads).forEach(payload => {
            Object.keys(payloads[payload]).forEach(key => {
                state.payloads[payload][key] = payloads[payload][key]
            })
        })
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
    defaultState,
}
